import React, {Component} from "react";
import TopLineMenu from "./TopLineMenu";
import TopLineSearch from "./TopLineSearch";

class TopLine extends Component {
	render() {
		return (
			<div className="topline">
				<TopLineMenu/>
				<TopLineSearch/>
			</div>
		);
	}
}

export default TopLine;


// WEBPACK FOOTER //
// ./src/app/pages/Main/TopLine/TopLine.js